import {combineReducers} from "redux";
import {hintReducer} from "./itemhint";
import {characterReducer} from "./character";

export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  }
}

const appReducer = combineReducers({
  hint: hintReducer,
  equipped: characterReducer,
});

export const rootReducer = (state, action) => {
  return appReducer(state, action);
};